var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOldNavyLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2500,
    height: 2500,
    viewBox: "0 0 192.756 192.756",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    d: "M0 0h192.756v192.756H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.378 67.838c-48.531 0-87.874 12.778-87.874 28.54 0 15.763 39.343 28.54 87.874 28.54 48.53 0 87.874-12.777 87.874-28.54 0-15.762-39.344-28.54-87.874-28.54z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.215 96.387c0 6.525-3.359 11.346-9.182 11.346-5.822 0-9.181-4.82-9.181-11.346 0-6.858 3.331-11.479 9.181-11.479 5.851 0 9.182 4.62 9.182 11.479z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.768 96.434c0 2.381.222 6.961 3.276 6.961s3.276-4.58 3.276-6.961c0-2.416-.318-7.248-3.276-7.248-2.958 0-3.276 4.832-3.276 7.248z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M61.67 107.398H50.482V85.243h5.634v18.327h5.554v3.828zM65.338 85.243h7.105c2.781 0 4.999.036 7.078 2.412 2.022 2.275 2.949 5.42 2.949 8.699 0 3.012-.899 6.156-2.668 8.33-1.91 2.377-4.297 2.715-6.965 2.715h-7.499V85.243z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.106 103.318c.787 0 1.292.076 2.022-.453.533-.416.955-.982 1.264-1.701.674-1.51.898-3.248.898-4.985 0-1.738-.365-4.004-1.18-5.439-.926-1.549-1.825-1.473-3.173-1.473h-.674v14.052h.843v-.001z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M102.863 107.398l-6.736-13.426v13.426h-5.42V85.243h5.487l6.695 13.345V85.243h5.408v22.155h-5.434zM122.512 103.279h-4.166l-1.116 4.119h-6.037l5.661-22.155h7.193l5.713 22.155h-6.211l-1.037-4.119z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.953 99.107l-1.488-8.201-1.486 8.201h2.974z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M141.328 107.398h-5.978l-5.34-22.155h5.871l2.406 12.497 2.113-12.497h6.323l-5.395 22.155zM160.459 96.633v10.765h-5.818V96.633l-5.94-11.39h5.807l2.99 6.366 3.387-6.366h5.287l-5.713 11.39z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOldNavyLogo);
export default __webpack_public_path__ + "static/media/OldNavyLogo.703ef08c9881205c232ec7a2413a3fde.svg";
export { ForwardRef as ReactComponent };